module.exports = __webpack_public_path__ + "img/upload-disabled.f5baf82e.svg";